import { createFileRoute } from '@tanstack/react-router';

import { getCompetitorQueryOptions } from '@/_pages/competitors/api-service';
import Loading from '@/_pages/competitors/notes/loading';

export const Route = createFileRoute('/_private/competitors/_template/$id/notes')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompetitorQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Notes',
    tabKey: 'competitor/notes',
  },
  pendingComponent: Loading,
});
